import { render } from "./UserAccountDashboard.vue?vue&type=template&id=c929cd1a&scoped=true"
import script from "./UserAccountDashboard.vue?vue&type=script&lang=js"
export * from "./UserAccountDashboard.vue?vue&type=script&lang=js"

import "./UserAccountDashboard.vue?vue&type=style&index=0&id=c929cd1a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c929cd1a"]])

export default __exports__